// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-reader {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  color: #fff;
}

.book-header {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #1e1e1e;
  border-radius: 8px;
}

.book-header h2 {
  margin: 0 0 10px 0;
  color: #fff;
}

.navigation-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  padding: 10px;
  background-color: #1e1e1e;
  border-radius: 8px;
}

.navigation-controls.bottom {
  margin-top: 30px;
}

.nav-button {
  padding: 10px 20px;
  background-color: #1a365d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.nav-button:hover:not(:disabled) {
  background-color: #3182ce;
}

.nav-button:disabled {
  background-color: #1a365d;
  cursor: not-allowed;
  opacity: 0.6;
}

.page-indicator {
  color: #e0e0e0;
  font-size: 16px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: white;
}

.loading-spinner {
  border: 4px solid #333;
  border-top: 4px solid #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.error-message {
  padding: 15px;
  background-color: rgba(255, 68, 68, 0.1);
  color: #ff4444;
  border-radius: 8px;
  margin: 20px 0;
  text-align: center;
}

.book-content {
  background-color: #1e1e1e;
  padding: 30px;
  border-radius: 8px;
  line-height: 1.6;
}

.content-container {
  font-size: 18px;
  color: #e0e0e0;
}

.content-container h1,
.content-container h2,
.content-container h3 {
  color: #fff;
  margin: 1em 0;
}

.content-container p {
  margin: 1em 0;
}

.content-container a {
  color: #4a9eff;
  text-decoration: none;
}

.content-container a:hover {
  text-decoration: underline;
}

/* ===== BUTTONS & CONTROLS ===== */
.modernize-button {
  background-color: #1a365d;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 16px;
  transition: background-color 0.3s ease;
}

.modernize-button.active {
  background-color: #1a365d;
}

.modernize-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.modernize-button:hover:not(:disabled) {
  background-color: #3182ce;
}

.quiz-button {
  background-color: #1a365d;
  color: white;
  padding: 5px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  font-size: 13px;
  margin: 10px auto;
  display: block;
  text-align: center;
}

.quiz-button:hover {
  background-color: #3182ce;
  transform: scale(1.05);
}

.quiz-button:disabled {
  background-color: #1a365d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* ===== LAYOUT SYSTEM ===== */
.book-reader-container {
  display: flex;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  transition: all 0.3s ease;
}

.book-reader {
  flex: 1 1;
  transition: all 0.3s ease;
  padding: 20px;
  overflow-y: auto;
  width: 100%;
}

/* Adjust book reader width when any panel is open */
.book-reader-container.with-panel .book-reader,
.book-reader-container.with-explanation .book-reader,
.book-reader-container.with-historical-context .book-reader {
  width: calc(100% - 400px);
  margin-right: 400px;
  transition: all 0.3s ease;
}

/* ===== SIDE PANELS ===== */
.side-panel {
  position: fixed;
  right: -400px;
  top: 0;
  width: 400px;
  height: 100vh;
  background: #1a1a1a;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);
  transition: right 0.3s ease;
  z-index: 1000;
  overflow-y: auto;
}

.side-panel.open {
  right: 0;
}

.panel-header {
  padding: 15px 20px;
  border-bottom: 1px solid #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #242424;
  position: sticky;
  top: 0;
  z-index: 10;
}

.panel-content {
  padding: 20px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

.close-panel-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 50%;
  color: #fff;
  transition: background-color 0.2s;
}

.close-panel-button:hover {
  background-color: #333;
}

.placeholder-text {
  color: #aaa;
  text-align: center;
  margin-top: 20px;
}

/* Apply side panel styles to all panel types */
.modernized-panel,
.explanation-panel,
.historical-context-panel {
  composes: side-panel;
}

/* Z-index management for panels */
.explanation-panel.open {
  z-index: 1001; /* Higher than modernize panel */
}

.historical-context-panel.open {
  z-index: 1002; /* Higher than explanation panel */
}

/* ===== TEXT FORMATTING ===== */
.explanation-text, .modernized-text {
  white-space: pre-line;
  line-height: 1.6;
  color: #e0e0e0;
  text-align: left;
  padding: 0;
}

.explanation-text p, .modernized-text p {
  margin-bottom: 1.2rem;
  margin-top: 0;
}

.explanation-text p strong, .modernized-text p strong {
  color: #fff;
  display: inline-block;
  margin-bottom: 0.5rem;
}

.explanation-text p:not(:first-child), .modernized-text p:not(:first-child) {
  padding-left: 0.5rem;
}

/* ===== PDF VIEWER ===== */
.pdf-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
  background: #f5f5f5;
  border-radius: 5px;
  overflow: auto;
}

.pdf-container .react-pdf__Document {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pdf-container .react-pdf__Page {
  margin: 10px auto;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

.pdf-container .react-pdf__Page__textContent {
  user-select: text;
  -webkit-user-select: text;
}

.pdf-container .react-pdf__message {
  padding: 20px;
  color: #666;
}

/* Make sure text in PDF is selectable for modernize/explain features */
.pdf-container span {
  -webkit-user-select: text !important;
          user-select: text !important;
  cursor: text;
}

/* Selection toolbar styles */
.selection-toolbar {
  position: absolute;
  background-color: #242424;
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: flex;
  gap: 4px;
}

.selection-toolbar button {
  background-color: #1a365d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.selection-toolbar button:hover {
  background-color: #3182ce;
}

/* ===== RESPONSIVE STYLES ===== */
@media (max-width: 768px) {
  .book-reader-container.with-panel .book-reader,
  .book-reader-container.with-explanation .book-reader,
  .book-reader-container.with-historical-context .book-reader {
    width: 100%;
    margin-right: 0;
  }
  
  .side-panel {
    width: 100%;
  }
  
  .modernized-panel.open,
  .explanation-panel.open,
  .historical-context-panel.open {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BookReader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA,oDAAoD;AACpD;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;;;EAGE,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE,aAAa,EAAE,kCAAkC;AACnD;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,uEAAuE;AACvE;EACE,oCAA4B;UAA5B,4BAA4B;EAC5B,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE;;;IAGE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,WAAW;EACb;AACF","sourcesContent":[".book-reader {\n  padding: 20px;\n  max-width: 800px;\n  margin: 0 auto;\n  color: #fff;\n}\n\n.book-header {\n  margin-bottom: 20px;\n  padding: 20px;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n}\n\n.book-header h2 {\n  margin: 0 0 10px 0;\n  color: #fff;\n}\n\n.navigation-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 20px 0;\n  padding: 10px;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n}\n\n.navigation-controls.bottom {\n  margin-top: 30px;\n}\n\n.nav-button {\n  padding: 10px 20px;\n  background-color: #1a365d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.nav-button:hover:not(:disabled) {\n  background-color: #3182ce;\n}\n\n.nav-button:disabled {\n  background-color: #1a365d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.page-indicator {\n  color: #e0e0e0;\n  font-size: 16px;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  color: white;\n}\n\n.loading-spinner {\n  border: 4px solid #333;\n  border-top: 4px solid #fff;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.error-message {\n  padding: 15px;\n  background-color: rgba(255, 68, 68, 0.1);\n  color: #ff4444;\n  border-radius: 8px;\n  margin: 20px 0;\n  text-align: center;\n}\n\n.book-content {\n  background-color: #1e1e1e;\n  padding: 30px;\n  border-radius: 8px;\n  line-height: 1.6;\n}\n\n.content-container {\n  font-size: 18px;\n  color: #e0e0e0;\n}\n\n.content-container h1,\n.content-container h2,\n.content-container h3 {\n  color: #fff;\n  margin: 1em 0;\n}\n\n.content-container p {\n  margin: 1em 0;\n}\n\n.content-container a {\n  color: #4a9eff;\n  text-decoration: none;\n}\n\n.content-container a:hover {\n  text-decoration: underline;\n}\n\n/* ===== BUTTONS & CONTROLS ===== */\n.modernize-button {\n  background-color: #1a365d;\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 16px;\n  transition: background-color 0.3s ease;\n}\n\n.modernize-button.active {\n  background-color: #1a365d;\n}\n\n.modernize-button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.modernize-button:hover:not(:disabled) {\n  background-color: #3182ce;\n}\n\n.quiz-button {\n  background-color: #1a365d;\n  color: white;\n  padding: 5px 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.2s;\n  font-size: 13px;\n  margin: 10px auto;\n  display: block;\n  text-align: center;\n}\n\n.quiz-button:hover {\n  background-color: #3182ce;\n  transform: scale(1.05);\n}\n\n.quiz-button:disabled {\n  background-color: #1a365d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* ===== LAYOUT SYSTEM ===== */\n.book-reader-container {\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow-x: hidden;\n  transition: all 0.3s ease;\n}\n\n.book-reader {\n  flex: 1;\n  transition: all 0.3s ease;\n  padding: 20px;\n  overflow-y: auto;\n  width: 100%;\n}\n\n/* Adjust book reader width when any panel is open */\n.book-reader-container.with-panel .book-reader,\n.book-reader-container.with-explanation .book-reader,\n.book-reader-container.with-historical-context .book-reader {\n  width: calc(100% - 400px);\n  margin-right: 400px;\n  transition: all 0.3s ease;\n}\n\n/* ===== SIDE PANELS ===== */\n.side-panel {\n  position: fixed;\n  right: -400px;\n  top: 0;\n  width: 400px;\n  height: 100vh;\n  background: #1a1a1a;\n  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.3);\n  transition: right 0.3s ease;\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.side-panel.open {\n  right: 0;\n}\n\n.panel-header {\n  padding: 15px 20px;\n  border-bottom: 1px solid #333;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #242424;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.panel-content {\n  padding: 20px;\n  height: calc(100% - 60px);\n  overflow-y: auto;\n}\n\n.close-panel-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 50%;\n  color: #fff;\n  transition: background-color 0.2s;\n}\n\n.close-panel-button:hover {\n  background-color: #333;\n}\n\n.placeholder-text {\n  color: #aaa;\n  text-align: center;\n  margin-top: 20px;\n}\n\n/* Apply side panel styles to all panel types */\n.modernized-panel,\n.explanation-panel,\n.historical-context-panel {\n  composes: side-panel;\n}\n\n/* Z-index management for panels */\n.explanation-panel.open {\n  z-index: 1001; /* Higher than modernize panel */\n}\n\n.historical-context-panel.open {\n  z-index: 1002; /* Higher than explanation panel */\n}\n\n/* ===== TEXT FORMATTING ===== */\n.explanation-text, .modernized-text {\n  white-space: pre-line;\n  line-height: 1.6;\n  color: #e0e0e0;\n  text-align: left;\n  padding: 0;\n}\n\n.explanation-text p, .modernized-text p {\n  margin-bottom: 1.2rem;\n  margin-top: 0;\n}\n\n.explanation-text p strong, .modernized-text p strong {\n  color: #fff;\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\n.explanation-text p:not(:first-child), .modernized-text p:not(:first-child) {\n  padding-left: 0.5rem;\n}\n\n/* ===== PDF VIEWER ===== */\n.pdf-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px 0;\n  background: #f5f5f5;\n  border-radius: 5px;\n  overflow: auto;\n}\n\n.pdf-container .react-pdf__Document {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.pdf-container .react-pdf__Page {\n  margin: 10px auto;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n}\n\n.pdf-container .react-pdf__Page__textContent {\n  user-select: text;\n  -webkit-user-select: text;\n}\n\n.pdf-container .react-pdf__message {\n  padding: 20px;\n  color: #666;\n}\n\n/* Make sure text in PDF is selectable for modernize/explain features */\n.pdf-container span {\n  user-select: text !important;\n  cursor: text;\n}\n\n/* Selection toolbar styles */\n.selection-toolbar {\n  position: absolute;\n  background-color: #242424;\n  border-radius: 4px;\n  padding: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n  z-index: 100;\n  display: flex;\n  gap: 4px;\n}\n\n.selection-toolbar button {\n  background-color: #1a365d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.selection-toolbar button:hover {\n  background-color: #3182ce;\n}\n\n/* ===== RESPONSIVE STYLES ===== */\n@media (max-width: 768px) {\n  .book-reader-container.with-panel .book-reader,\n  .book-reader-container.with-explanation .book-reader,\n  .book-reader-container.with-historical-context .book-reader {\n    width: 100%;\n    margin-right: 0;\n  }\n  \n  .side-panel {\n    width: 100%;\n  }\n  \n  .modernized-panel.open,\n  .explanation-panel.open,\n  .historical-context-panel.open {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
